var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2514 0.498047C16.9844 0.498047 18.4007 1.85437 18.4963 3.56352L18.5014 3.74794L18.5008 15.7518C18.5006 17.5466 17.0456 19.0017 15.2507 19.0017H3.25006C1.51701 19.0017 0.10076 17.6454 0.00514007 15.9362L0 15.7518L0.0006001 3.74796C0.0008101 1.95313 1.45582 0.498047 3.25065 0.498047H15.2514ZM8.5 7.49805L1.5 7.49905L1.5001 15.7517L1.50728 15.9124C1.58839 16.8036 2.33765 17.5017 3.25 17.5017L8.5 17.501V7.49805ZM17 13.498L10 13.499V17.501L15.2506 17.5017C16.2172 17.5017 17.0007 16.7181 17.0008 15.7516L17 13.498ZM15.2514 1.99805L10 1.99705V11.999L17 11.998L17.0013 3.74802L16.9941 3.58729C16.913 2.69609 16.1638 1.99805 15.2514 1.99805ZM8.5 1.99705L3.25073 1.99805L3.10723 2.00386C2.20785 2.07693 1.50071 2.82994 1.5006 3.74808L1.5 5.99905L8.5 5.99805V1.99705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewActive);
export default __webpack_public_path__ + "static/media/overview_active.d378db00ef921bdfc5aa0f3304bb5531.svg";
export { ForwardRef as ReactComponent };